import { render } from "./InformationComponent.vue?vue&type=template&id=c355c41c&ts=true"
import script from "./InformationComponent.vue?vue&type=script&lang=ts"
export * from "./InformationComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__